// models/Appointment/Appointment.ts
import { User } from 'modules/users/models/User'
import { Query } from '../../../common/api/Query'
import { ExternAppointmentStatus } from '../enums/ExternAppointmentStatus'
import { ExternAppointmentSchedule } from './ExternAppointmentSchedule'

export type ExternAppointmentProps = {
  id?: string
  requester: User
  patient: User
  professional: User
  scheduleId: string
  schedule: ExternAppointmentSchedule
  status: ExternAppointmentStatus
  rate?: number | null
  date: Date
  initialMessage?: string
  cancelMessage?: string
  rateMessage?: string
  cancelUserId?: string | null
  createdAt: string
  updatedAt: string
}

export class ExternAppointment {
  constructor(private readonly props: ExternAppointmentProps) {}

  get id(): string | undefined {
    return this.props.id
  }

  get requester(): User {
    return this.props.requester
  }

  get patient(): User {
    return this.props.patient
  }

  get professional(): User {
    return this.props.professional
  }

  get scheduleId(): string {
    return this.props.scheduleId
  }

  get status(): ExternAppointmentStatus {
    return this.props.status
  }

  get rate(): number | null | undefined {
    return this.props.rate
  }

  get date(): Date {
    return this.props.date
  }

  get initialMessage(): string | undefined {
    return this.props.initialMessage
  }

  get cancelMessage(): string | undefined {
    return this.props.cancelMessage
  }

  get rateMessage(): string | undefined {
    return this.props.rateMessage
  }

  get cancelUserId(): string | null | undefined {
    return this.props.cancelUserId
  }

  get createdAt(): string {
    return this.props.createdAt
  }

  get updatedAt(): string {
    return this.props.updatedAt
  }

  get schedule(): ExternAppointmentSchedule {
    return this.props.schedule
  }

  set date(value: Date) {
    this.props.date = value
  }

  get dateFrom(): Date {
    return new Date(this.props.date)
  }
  get dateTo(): Date {
    const originalDate = new Date(this.props.date)
    originalDate.setHours(originalDate.getHours() + 1)
    return originalDate
  }
}

export class ExternAppointmentQuery extends Query<ExternAppointment> {
  requesterID?: string
  patientID?: string
  professionalID?: string
  scheduleId?: string
  status?: ExternAppointmentStatus[]
  dateFrom?: Date
  dateTo?: Date
}
